import { GET_AREAS } from './const';
import labels from '../i18n';

export default (lang) => ({
  type: GET_AREAS,
  payload: [
    {
      label: 'Arts',
      value: 1000,
      topics: labels[lang].areas.ar,
    }, {
      label: 'Health',
      value: 2000,
      topics: labels[lang].areas.he,
    }, {
      label: 'Natural Sciences',
      value: 7000,
      topics: labels[lang].areas.nat,
    }, {
      label: 'Technical Sciences',
      value: 5000,
      topics: labels[lang].areas.tech,
    }, {
      label: 'School of Business and Social Sciences',
      value: 3000,
      topics: labels[lang].areas.bss,
    }, {
      label: 'Aarhus Institute of Advanced Studies',
      value: 1954,
      topics: labels[lang].areas.aias,
    },
  ],
});
